import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../ui/alert-dialog';

const ConfirmPaymentDialog = ({
  isOpen,
  onClose,
  doctorToPay,
  onConfirm
}) => {
  return (
    <AlertDialog open={isOpen} onOpenChange={onClose}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Confirmar Pago de Comisión</AlertDialogTitle>
          <AlertDialogDescription>
            {doctorToPay && (
              <>
                ¿Confirmar que se pagó <strong className="text-emerald-600">Q{doctorToPay.comision?.toFixed(2)}</strong> al{' '}
                <strong>{doctorToPay.medico_referente}</strong>?
                <br /><br />
                Esta acción registrará el pago y no se puede deshacer.
              </>
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancelar</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className="bg-emerald-600 hover:bg-emerald-700"
          >
            Confirmar Pago
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default ConfirmPaymentDialog;
